import React, { useState } from 'react';
import './Avatar.styles.css';
import { AvatarPopUp } from './AvatarPopUp';
import { NavLink } from 'react-router-dom';
import { imageSrc } from '../../utils/imageUrl';

interface AvatarProps {
  userId: string;
  displayName?: string;
  userName?: string;
  imageUrl?: string;
  // Accessible name for the profile link. The avatar image is decorative
  // (alt=""), so without this the link has no accessible name for screen readers.
  linkLabel?: string;
}

export const Avatar: React.FC<AvatarProps> = (props) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);

  const handleMouseEnter = async (_event: React.MouseEvent<HTMLDivElement>) => {
    setShowPopup(true);
  };
  const handleMouseLeave = async (_event: React.MouseEvent<HTMLDivElement>) => {
    setShowPopup(false);
  };

  return (
    <div className='avatar' onClick={(event) => event.stopPropagation()}>
      <div className='avatar-image-container'
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <NavLink to={`/profile/${props.userId}`} aria-label={props.linkLabel}>
          <img
            src={!props.imageUrl ? '/profile-man.png' : imageSrc(props.imageUrl, 'thumb')} alt=""
            className='bg-gray-200 rounded-full'
          />
        </NavLink>
        {
          showPopup
            ? <AvatarPopUp {...props} />
            : null
        }
      </div>
    </div>
  );
};
